import { Controller } from '@hotwired/stimulus'
import { mountCallWidget, unmountCallWidget } from '../components/call_center/widget/CallWidget'

export default class extends Controller {
  static values = {
    apiBase: String
  }

  connect() {
    mountCallWidget(this.element)
  }

  disconnect() {
    unmountCallWidget(this.element)
  }
}
